import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[dialog-component-host]',
})
export class DialogComponentDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}